import Vue from 'vue'
import Vuex from 'vuex'
import setting from './modules/setting'
import getters from './getters'
import user from './modules/user'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    setting,
    user
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js